
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M10.115 16.109c0-.492.39-.891.87-.891.495 0 .87.4.87.89 0 .508-.375.892-.87.892a.872.872 0 01-.87-.891zM8.9 8.074L8 7.152C8.825 6.4 9.8 6 10.955 6 12.92 6 14 7.306 14 8.811c0 2.243-2.325 1.982-2.325 4.133v.891h-1.38v-.89c0-2.75 2.265-2.705 2.265-4.118 0-.707-.495-1.567-1.635-1.567-.75 0-1.53.338-2.025.814z"}}),_c('path',{attrs:{"d":"M1.89 4.835a1 1 0 011.657 1.121 9 9 0 102.606-2.538 1 1 0 11-1.077-1.686A11 11 0 111.89 4.835z","fill-rule":"nonzero"}})])])
          )
        }
      }
    